<template>
  <div class="userCenter" v-cloak>
    <div class="boxCenter">
      <div class="userBox">
        <LeftSide></LeftSide>
        <div class="userRight">
          <div class="userTitle">推广奖励<span class="role"> ({{(userData && userData.isDistr == 1) ? '普通会员' : '分销员'}})</span> 
            <span class="total-score">总计：
            <span style="color: red" v-if="activeName == 'second'">{{totalReward}}</span>
            <span style="color: red" v-if="activeName == 'first'">{{distrSecondOrderSum}}</span>
             {{(userData && userData.isDistr == 1) ? '分' : '元'}}</span>
          </div>
          <div class="scoreBox">
            <el-tabs v-model="activeName" type="card" v-if="userData.isDistr == 2" @tab-click="handleClick">
              <el-tab-pane label="伙伴分销提成" name="first"></el-tab-pane>
              <el-tab-pane label="分销提成" name="second"></el-tab-pane>
            </el-tabs>
            <el-table :data="tableData" border  style="width: 100%" v-show="activeName == 'first'">
              <el-table-column prop="name" label="伙伴姓名"></el-table-column>
              <el-table-column prop="phoneNum" label="伙伴电话"></el-table-column>
              <el-table-column prop="paySum" label="订单实付金额(元)"></el-table-column>
              <el-table-column prop="deductSum" label="订单提成金额(元)"></el-table-column>
            </el-table>
            <el-table :data="tableData" border  style="width: 100%" v-show="activeName != 'first'">
              <el-table-column prop="payTime" label="订单时间">
                <template slot-scope="scope">
                  <span>{{scope.row.payTime?scope.row.payTime.substring(0,19):''}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="memberName" label="下单人姓名"></el-table-column>
              <el-table-column prop="name" label="活动名称"></el-table-column>
              <el-table-column prop="pay" label="订单实付金额(元)"></el-table-column>
              <el-table-column prop="deduct" :label="userData.isDistr == 1 ? '订单提成(分)' : '订单提成(元)'"></el-table-column>
            </el-table>
            <div style="padding:50px;text-align: center">
              <el-pagination
                background
                layout="prev, pager, next"
                @current-change="handleCurrentChange"
                :current-page="pageIndex"
                :page-size="10"
                :total="total">
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import LeftSide from './common/leftside'
  import eventVue from '../bus.js'
  export default {
    components: {
      LeftSide
    },
    data(){
      return {
        userId:9,
        role:2,
        totalReward:0,
        distrSecondOrderSum:0,
        activeName:'second',

        tableData: [],
        pageIndex:1,
        total:0,
        totalScore:0,
      }
    },
    computed: {
      userData() {
        return this.$store.state.userData
      }
    },
    watch: {
      userData: {
        handler(newName, oldName){
          if (newName) {
            this.loadTotalReward()
            this.getDistrPartnerSum()
            if(newName.isDistr == 2){
              this.activeName = 'first'
              this.getDistrPartnerDetailListByPage()
            }else{
              this.getDistributionItem()
            }
          }
        },
        immediate: true
      }
    },
    created(){
      // this.loadTotalReward()
      // if(this.role == 2){
      //   this.activeName = 'first'
      //   this.getDistrPartnerDetailListByPage()
      // }else{
      //   this.getDistributionItem()
      // }
    },
    mounted(){
      eventVue.$emit("leftSwitch",'5')
    },
    methods:{
      //获取总积分或者总提成
      loadTotalReward(){
        this.$https.get('/api/distribution/getDistrOrderSum?memberId='+this.userData.id).then((res)=>{
          if(this.userData.isDistr == 2){
              this.totalReward = parseFloat(res.data).toFixed(2)
          }else{
              this.totalReward = res.data
          }
        }).catch((error) => {});
      },
      //获取获取伙伴分销总提成
      getDistrPartnerSum(){
          this.$https.get('/api/distribution/getDistrPartnerSum?memberId='+this.userData.id).then(res => {
              this.distrSecondOrderSum = parseFloat(res.data).toFixed(2)
          });
      },
      //获取积分或者提成明细
      getDistributionItem(){
          this.$https.get('/api/distribution/pageIndex/'+this.pageIndex+'/pageNum/10?memberId='+this.userData.id,{}).then(res => {
              res.data.records.forEach(item => {
                item.pay = parseInt(item.pay).toFixed(2)
                if(this.userData.isDistr == 2){
                  item.deduct = parseInt(item.deduct).toFixed(2)
                }
              })
              this.tableData = res.data.records
              this.total = res.data.total
          });
      },
      //获取伙伴分销列表明细
      getDistrPartnerDetailListByPage(){
          this.$https.get('/api/distribution/getDistrPartnerDetailListByPage/pageIndex/'+this.pageIndex+'/pageNum/10?memberId='+this.userData.id,{}).then(res => {
            res.data.records.forEach(item => {
                item.paySum = parseInt(item.paySum).toFixed(2)
                item.deductSum = parseInt(item.deductSum).toFixed(2)
              })
              this.tableData = res.data.records
              this.total = res.data.total
          });
      },
      //分销商查看分销列表切换
      handleClick(val){
        this.pageIndex = 1
        if(val.name == 'second'){
          this.getDistributionItem()
        }else{
          this.getDistrPartnerDetailListByPage()
        }
      },

      handleCurrentChange(val){
        this.pageIndex = val
        this.loadData()
      },
    }
  }
</script>

<style scoped>
  [v-cloak]{
    display: none;
}
  .scoreBox{
    padding: 20px;
  }
  .total-score{
    float: right;
    font-size: 14px;
    margin-right: 30px;
    font-weight: normal;
  }
  .editBtn{
    position: absolute;
    color: #5680f9;
    right: 20px;
    top: 14px;
    font-size: 16px;
    cursor: pointer;
  }
  .editBox{
    padding:27px 0 0 193px;
    overflow: hidden;
  }
  .editBox span{
    float: left;
    width: 96px;
    text-align: center;
    height: 38px;
    line-height: 38px;
    border: 1px solid #E5E5E5;
    border-radius: 4px;
    font-size: 14px;
    color: #919191;
    margin-right: 20px;
    cursor: pointer;
  } 
  .editBox .save{
    color: #ffffff;
    background: #FFCD30;
    border: 1px solid #FFCD30;
  }
  .role{
    font-size: 14px;
    
  }
</style>



// WEBPACK FOOTER //
// src/components/reward.vue